module.exports = __webpack_public_path__ + "static/grafika4-8a88d7c227530b9a077871aee80ab455.png";